export default "__VITE_ASSET__COWAakY2__"